import { useEffect } from "react"

// Re-runs Formik validation when state that lives outside Formik changes
// (consent checkboxes, star ratings), so errors that depend on it clear or
// appear right away instead of waiting for the next field edit. Only after the
// first submit attempt, matching when errors are shown at all.
//
//   <Revalidate formik={props} on={[smsConsented]} />
const Revalidate = ({ formik, on = [] }) => {
    const { submitCount, validateForm } = formik
    useEffect(() => {
        if (submitCount > 0) validateForm()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, on)
    return null
}

export default Revalidate
